module.exports = __webpack_public_path__ + "img/feedback3.36c83b61.svg";